import type { SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";

/**
 * Untyped access for tables/views newer than src/integrations/supabase/types.ts
 * (app_translations, v_lapsed_buyers, …). Regenerating the types removes the
 * need for this; until then it keeps the new pages type-clean.
 */
export const db = supabase as unknown as SupabaseClient;
